import { supabase } from './supabase';
import {
  ensurePlayerRecord,
  resolveRegistrationProfile,
} from '../services/playerOnboardingService';

const AUTH_SHELL_PATHS = new Set([
  '/auth/callback',
  '/auth/complete-profile',
  '/reset-password',
]);

/** Public auth pages that do not require currentUser, but still hydrate if a session exists. */
const PUBLIC_AUTH_PATHS = new Set([
  '/login',
  '/signup',
]);

export const isAuthShellPath = (pathname) => AUTH_SHELL_PATHS.has(pathname);

export const isPublicAuthPath = (pathname) => PUBLIC_AUTH_PATHS.has(pathname);

export const hasCompleteRegistrationMetadata = (authUser) => {
  const { first_name, last_name, gender } = resolveRegistrationProfile(authUser);
  return Boolean(first_name && last_name && gender);
};

export const resolveSessionForApp = async (session, pathname, callbacks) => {
  const { setCurrentUser, navigate, setError, onSignOut } = callbacks;

  if (!session?.user) {
    setCurrentUser(null);
    return 'no_session';
  }

  if (isAuthShellPath(pathname)) {
    return 'shell_skip';
  }

  try {
    const { data: playerData, error: playerError } = await supabase
      .from('players')
      .select('*')
      .eq('auth_id', session.user.id);

    if (playerError) throw playerError;

    if (playerData && playerData.length > 0) {
      setCurrentUser({
        ...session.user,
        ...playerData[0],
      });
      return 'hydrated';
    }

    if (hasCompleteRegistrationMetadata(session.user)) {
      const onboarding = await ensurePlayerRecord(session.user);
      if (onboarding.created || onboarding.existed) {
        const { data: createdPlayer, error: refetchError } = await supabase
          .from('players')
          .select('*')
          .eq('auth_id', session.user.id);
        if (refetchError) throw refetchError;
        if (createdPlayer?.[0]) {
          setCurrentUser({
            ...session.user,
            ...createdPlayer[0],
          });
          return 'hydrated';
        }
      }
    }

    console.log('[AUTH] session without player row — redirecting to complete-profile');
    navigate('/auth/complete-profile', { replace: true });
    return 'onboarding_redirect';
  } catch (err) {
    console.error('[AUTH] resolveSessionForApp error', err?.message || err, err);
    if (setError) {
      setError('Error loading user data. Please try logging in again.');
    }
    if (onSignOut) {
      await onSignOut();
    } else {
      await supabase.auth.signOut();
    }
    setCurrentUser(null);
    return 'error';
  }
};
